import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';
import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import DropDown from '../../../menus/drop-down-react/drop-down';
import {getSortOptions, useGetValue} from './sort-dropdown-provider';
import { SortEnum } from './sort-enum';
import { IDropDownOption } from '../../../menus/drop-down-react/interfaces';


/**
 * Sort dropdown widget.
 */
export const SortDropDown = () => {

    const dispatch = useAppDispatch();
    const value = useGetValue();
    const showPriceSorting = useAppSelector(store => store.showPriceSorting);

    /**
     * apply the sorting
     */
    const applySort = (selection: SortEnum) => {

        const updatedState = {
            currentPage: 0,
            sortType: '',
            sortOrder: '',
            sortProperty: '',
        };

        switch (selection){
            case SortEnum.PriceAsc: {
                updatedState.sortType = 'number'; // text|number|datetime
                updatedState.sortOrder = 'asc'; // asc or desc
                updatedState.sortProperty = 'skuPrice';
                break;
            }
            case SortEnum.PriceDesc: {
                updatedState.sortType = 'number'; // text|number|datetime
                updatedState.sortOrder = 'desc'; // asc or desc
                updatedState.sortProperty = 'skuPrice';
                break;
            }
            case SortEnum.MostReviewed: {
                updatedState.sortType = 'number'; // text|number|datetime
                updatedState.sortOrder = 'desc'; // asc or desc
                updatedState.sortProperty = 'reviewsTotal';
                break;
            }
            case SortEnum.NameAsc: {
                updatedState.sortType = 'text'; // text|number|datetime
                updatedState.sortOrder = 'asc'; // asc or desc
                updatedState.sortProperty = 'documentName';
                break;
            }
            case SortEnum.NameDesc: {
                updatedState.sortType = 'text'; // text|number|datetime
                updatedState.sortOrder = 'desc'; // asc or desc
                updatedState.sortProperty = 'documentName';
                break;
            }
            default: {
                updatedState.sortType = 'number'; // text|number|datetime
                updatedState.sortOrder = 'asc'; // asc or desc
                updatedState.sortProperty = 'mainOrder';
                break;
            }
        }

        dispatch(rootActions.refreshAndStorage(updatedState));
    };

    return (
        <DropDown
            width="200px"
            selectedValue={ value }
            zIndex={ 11 }
            panelClasses="flex items-center border md:border-0 rounded text-gray-450 px-4 py-1 h-10 md:h-auto justify-center md:justify-start text-center"
            title="Sort Products"
            onSelect={(option: IDropDownOption) => {
                applySort(Number(option.value) || 0);
                sendGAEvent('JPList', `Top Sort: ${ option.text }`);
            }}
            options={ getSortOptions(showPriceSorting) } />
    )
};